const workflows = {
  title: "Flujos",
  start: "Iniciar Flujo",
  saved: "Flujo guardado",
  deleted: "Flujo eliminado",
  empty: "No hay flujos disponibles.",
};

export default workflows;
